import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import cropdarpanLogo from '../assets/images/logo.png';
import cottonImage from '../assets/images/cotton.png';
import paddyImage from '../assets/images/paddy.png';
import chilliImage from '../assets/images/chilli.png';
import { fetchCrops } from '../api/cropService'; 
import { setLanguage, getLanguageFromCode, getCurrentLanguage } from '../api/languageHelper';

const ExternalHome = () => {
  const { t } = useTranslation();  const [crops, setCrops] = useState([]);
  const [selectedCrop, setSelectedCrop] = useState(() => {
    const savedCrop = sessionStorage.getItem('selectedCrop');
    if (savedCrop) {
      const parsedCrop = JSON.parse(savedCrop);
      return parsedCrop.name;
    }
    return t('cotton'); // Default crop name
  });
  const [selectedLanguage, setSelectedLanguage] = useState('English');
  const navigate = useNavigate();
  useEffect(() => {
    // Set initial language from localStorage
    const currentLang = getCurrentLanguage();
    setSelectedLanguage(getLanguageFromCode(currentLang));
    
    // Fetch crops when component mounts
    const loadCrops = async () => {
      try {
        const cropList = await fetchCrops();
        setCrops(cropList);
        
        // Check for previously selected crop in sessionStorage
        const savedCrop = sessionStorage.getItem('selectedCrop');
        if (savedCrop) {
          const parsedCrop = JSON.parse(savedCrop);
          setSelectedCrop(parsedCrop.name);
        } else if (cropList.length > 0) {
          setSelectedCrop(cropList[0].name);
        }
      } catch (err) {
        console.error('Error fetching crops:', err);
      }
    };

    loadCrops();
  }, []);

  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
    setLanguage(language);
  };
  const handleProceed = () => {
    const selected = crops.find(c => c.name === selectedCrop) || crops[0]; // Default to first crop if not found
    if (selected) {
      sessionStorage.setItem('selectedCrop', JSON.stringify(selected));
      navigate(`/home`);
    } else {
      alert(t('common.error'));
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="flex flex-col items-center justify-center px-4 py-12">
        {/* Logo */}
        <div className="w-60 mb-6">
          <img src={cropdarpanLogo} alt="Crop Darpan Logo" className="w-full" />
        </div>


        {/* Title Section */}
        <div className="text-center mb-5">
          <h1 className="text-2xl font-bold text-blue-700 mb-3">
            {t('home.title')}
            <p className="text-xs text-gray-500 mt-1">({t('home.version')} 3)</p>
          </h1>
        </div>

        {/* Main Form Container */}
        <div className="w-full max-w-md">
          <div className="bg-gray-100 border border-gray-300 rounded-lg p-6 py-4 shadow-sm">
            {/* Selection Fields */}
            <div className="space-y-4 mb-6">
              {/* Crop Selection */}
              {/* <div className="flex items-center">
                <label className="w-24 text-right pr-4 font-medium text-gray-800">{t('home.Crop')}</label>
                <div className="flex-1">
                  <select
                    value={selectedCrop}
                    onChange={(e) => setSelectedCrop(e.target.value)}
                    className="w-full border border-gray-400 rounded px-3 py-2 bg-white text-gray-800 focus:outline-none focus:border-blue-500"
                  >
                    {crops.map((crop) => (
                      <option key={crop.cid} value={crop.name}>
                        {crop.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div> */}

              {/* Language Selection */}
              {/* <div className="flex items-center">
                <label className="w-24 text-right pr-4 font-medium text-gray-800">{t('home.Language')}</label>
                <div className="flex-1">
                  <select
                    value={selectedLanguage}
                    onChange={(e) => handleLanguageChange(e.target.value)}
                    className="w-full border border-gray-400 rounded px-3 py-2 bg-white text-gray-800 focus:outline-none focus:border-blue-500"
                  >
                    <option value="English">English</option>
                    <option value="Telugu">Telugu</option>
                  </select>
                </div>
              </div> */}

              {/* <div className="w-full text-center bg-green-600 text-white font-semibold py-2 rounded-md"> */}
              <div className="w-full text-center font-semibold text-xl rounded-md">
                {t('home.selectCrop')}
              </div>
              {/* Crop Selection */}
              <div className="p-1 grid grid-cols-3 gap-3 justify-center">
                {crops.map((crop) => {
                  const getImagePath = () => {
                    if (crop.cid === 1) return cottonImage;
                    if (crop.cid === 2) return paddyImage;
                    if (crop.cid === 3) return chilliImage;
                    return null;
                  };

                  return (
                    <button
                      key={crop.cid}
                      onClick={() => setSelectedCrop(crop.name)}
                      data-crop={crop.name}
                      aria-pressed={selectedCrop === crop.name}
                      className={`crop-card group flex flex-col items-center justify-center gap-2 rounded-xl p-1 shadow-md transition 
                        ${selectedCrop === crop.name
                                    ? 'bg-green-600 text-white'
                                    : 'bg-white text-gray-800 hover:bg-gray-200'
                                  }
                      `}
                    >
                      <img
                        src={getImagePath()}
                        alt={crop.name}
                        className="w-14 h-14 object-contain"
                      />
                      <span className="font-medium">{crop.name}</span>
                    </button>
                  );
                })}
              </div>
            </div>            
            <div className="text-sm text-center mb-4 space-y-2">    
              <p>
                {t('home.developedBy')} &nbsp;
                <a
                  href={t('home.link1')}
                  className="underline hover:text-blue-900 transition-colors duration-200"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('home.line1')}
                </a>
              
                &nbsp;{t('and')} &nbsp;

                {selectedCrop && selectedCrop.cid === 3 ? (
                  <>
                    <a
                      href={t('home.chilli.link2')}
                      className="underline hover:text-blue-900 transition-colors duration-200"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t('home.chilli.line2')}
                    </a>
                    &nbsp;{t('and')}&nbsp;
                    <a
                      href={t('home.chilli.link3')}
                      className="underline hover:text-blue-900 transition-colors duration-200"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t('home.chilli.line3')}
                    </a>
                  </>
                ) : (
                  <a
                    href={t('home.link2')}
                    className="underline hover:text-blue-900 transition-colors duration-200"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t('home.line2')}
                  </a>
                )}
              </p>
            </div>
            {/* Action Button */}
            <div className="space-y-4">
              <div className="text-center">
                {/* <p className="text-green-600 text-sm mb-3">{t('home.proceedPrompt')}</p> */}
                <button
                  onClick={handleProceed}
                  className="w-full bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded font-medium transition-colors duration-200"
                >
                  {t('home.proceedButton')}
                </button>
              </div>
            </div>

            {/* Bottom Navigation Buttons */}
            <div className="flex justify-between gap-4 pt-6 mt-6 border-t">
              <button
                onClick={() => navigate('/about')}
                className="bg-blue-600 border border-gray-300 text-white py-2 px-4 rounded flex-1 text-center hover:bg-blue-700"
              >
                {t('home.aboutCropDarpan')}
              </button>
              <button
                onClick={() => navigate('/about-us')}
                className="bg-blue-600 border border-gray-300 text-white py-2 px-4 rounded flex-1 text-center hover:bg-blue-700"
              >
                {t('home.aboutUs')}
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default ExternalHome;